module.exports = __webpack_public_path__ + "static/media/contact_info.5b07af41.svg";